<template>
  <div class="transaction-purposes">
    <span class="label">Назначение</span>
    <div class="purposes-grid" :style="gridStyle">
      <v-btn
        v-for="item in purposes"
        :key="item.value"
        class="purpose-button"
        :class="{active: item.value === value}"
        large
        @click="$emit('input', item.value)"
      >
        {{ item.description }}
      </v-btn>
    </div>
    <v-textarea
      v-if="value"
      :value="comment"
      class="purpose-comment"
      :placeholder="commentPlaceholder"
      rows="3"
      outlined
      hide-details
      @input="$emit('update:comment', $event)"
    />
  </div>
</template>

<script>
  export default {
    name: 'TransactionPurposes',
    model: {
      prop: 'value',
      event: 'input',
    },
    props: {
      value: {
        type: String,
        default: null,
      },
      comment: {
        type: String,
        default: '',
      },
      purposes: {
        type: Array,
        default: () => [],
      },
      columns: {
        type: Number,
        default: 2,
      },
    },
    computed: {
      commentPlaceholder () {
        return this.value === 'other' ? 'Опишите назначение' : 'Комментарий (необязательно)'
      },
      gridStyle () {
        return { gridTemplateColumns: `repeat(${this.columns}, 1fr)` }
      },
    },
  }
</script>

<style lang="less" scoped>
  .transaction-purposes {
    .label {
      display: block;
      margin-bottom: 5px;
      font-size: 18px;
      font-weight: 500;
    }

    .purposes-grid {
      display: grid;
      gap: 12px;
      margin-bottom: 12px;

      .purpose-button {
        height: 80px;
        border-radius: 10px;
        font-size: 16px;
        text-transform: none;
        //background-color: @color-secondary;
        //box-shadow: 0 3px 6px #00000029 !important;
        transition: all 0.3s ease;

        background-color: #f1f3f6 !important;

        &.active {
          background-color: @color-primary !important;
          color: #fff;
        }

        ::v-deep {
          .v-btn__content {
            max-width: 99%;
            text-wrap: initial;
          }
        }
      }
    }

    .purpose-comment {
      ::v-deep {
        .v-input__slot {
          border-radius: 10px;
          background-color: @color-secondary;
          border-color: @color-btn-grey;
          //box-shadow: 0 3px 6px #00000029 !important;
        }
      }
    }

  }
</style>
